{
	"labels": {
		"potrditevI": "Potrditev identitete",
		"vnesiKodo": "Vnesite kodo zgenerirano v avtentikatorju",
		"napacnaKoda": "Vpisana koda je napačna, poskusite znova"
	},
	"buttons": {
		"potrdiK": "Potrdi"
	},
	"obvestila": {
		"napakaKode": "Avtentikacija ni uspela! Vpisana koda ni pravilna",
		"avtUspesna": "Avtentikacija uspešna",
		"napaka": "Avtentikacija ni uspela!",
		"praznoPolje": "Polje s kodo ne sme biti prazno!"
	}
}